import React from 'react';
import { styled } from '@mui/material';

interface Props {
	text: string | number;
}
const TabBadge = (props: Props) => {
	const { text } = props;
	return <Badge>{!!text ? text : ''}</Badge>;
};

const Badge = styled('span')(({ theme }) => ({
	background: theme.palette.primary.main,
	color: theme.palette.primary.contrastText,
	minWidth: 22,
	paddingInline: 7,
	height: 22,
	borderRadius: 11,
	fontSize: '1.3rem',
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	marginLeft: theme.spacing(1),
	fontWeight: 'bold',
	lineHeight: 0,
}));

export default TabBadge;
